export { View as Technologies } from './view'
